export const categories = [
  {
    id: "cat-1",
    name: "企业服务",
    slug: "enterprise-services",
    icon: "ri-building-line",
    count: 128,
    subCategories: ["工商注册", "知识产权", "ISO认证", "企业咨询"],
  },
  {
    id: "cat-2",
    name: "软件开发",
    slug: "software-development",
    icon: "ri-code-box-line",
    count: 256,
    subCategories: ["网站开发", "APP开发", "小程序", "系统定制"],
  },
  {
    id: "cat-3",
    name: "设计策划",
    slug: "design-planning",
    icon: "ri-palette-line",
    count: 189,
    subCategories: ["品牌设计", "UI/UX设计", "活动策划", "文案策划"],
  },
  {
    id: "cat-4",
    name: "营销推广",
    slug: "marketing",
    icon: "ri-megaphone-line",
    count: 167,
    subCategories: ["SEO优化", "社交媒体", "广告投放", "内容营销"],
  },
  {
    id: "cat-5",
    name: "财税法务",
    slug: "finance-legal",
    icon: "ri-scales-line",
    count: 95,
    subCategories: ["代理记账", "税务筹划", "法律咨询", "合同审核"],
  },
  {
    id: "cat-6",
    name: "办公商务",
    slug: "office-business",
    icon: "ri-briefcase-line",
    count: 143,
    subCategories: ["办公租赁", "设备采购", "翻译服务", "商务接待"],
  },
];